import React from 'react';
import {AudioFile} from "types/MediaFile";
import {toTitleCase} from "services/string";
import {PlayIcon} from "@heroicons/react/outline";

type Props = {
    file: AudioFile
}

function AudioArticle({file}: Props) {
    return (
        <li className="px-8 py-4">
            <article className="flex justify-between items-center">
                <h3 className="text-base font-semibold">{toTitleCase(file.name)}</h3>
                <div className="flex items-center">
                    <PlayIcon className="mr-3 text-brand h-8 w-8 flex-shrink-0"/>
                    <span
                        className="text-sm text-gray-500 font-semibold">{file.duration.toHuman()}</span>
                </div>
            </article>
        </li>
    );
}

export default AudioArticle;